import React, { lazy, Suspense } from 'react';
import type { PDFReaderProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/PDFReader/index';

const PDFReader = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const PDFReaderSuspense: React.FC<PDFReaderProps> = (props) => (
  <Suspense fallback={renderLoader()}>
    <PDFReader {...props} />
  </Suspense>
);

export default PDFReaderSuspense;
